import { useGetPickUpsQuery } from '../../Shippings/services/visits.service';
import { PickUpFilters, PickUpVisit } from '../models';
import { skipToken } from '@reduxjs/toolkit/query';

interface UsePickUpsProps {
  filters?: PickUpFilters;
  page: number;
  pageSize: number;
  skip?: boolean;
}

const usePickUps = ({
  filters,
  page,
  pageSize,
  skip = false,
}: UsePickUpsProps) => {
  const { data, isLoading, error } = useGetPickUpsQuery(
    skip
      ? skipToken
      : {
          paginated: { page, pageSize },
          filters,
        }
  );

  const count = data?.paging?.count ?? (data as any)?.count ?? 0;
  const rows = data?.paging?.items ?? (data as any)?.items ?? [];

  return {
    pickUps: rows as unknown as PickUpVisit[],
    totalItems: count,
    totalPages: count ? Math.ceil(count / pageSize) : 0,
    totalPicked: data?.totalPicked ?? 0,
    isLoading,
    error,
  };
};

export default usePickUps;
